module.exports = __webpack_public_path__ + "static/img/Logo14_BusinessTraveller.8b6d6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo14_BusinessTraveller.png
// module id = 237
// module chunks = 1